export const IA_TEXT_MAX_LENGTH = 3000;
export const TEXT_MAX_LENGTH = 2000;
export const TEXT_MEDIUM_LENGTH = 1000;
export const TEXT_SHORT_LENGTH = 200;
export const TEXT_SMALL_LENGTH = 70;
export const TEXT_EXTRA_SMALL_LENGTH = 30;
export const TEXT_EXTRA_SHORT_LENGTH = 300;
